import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import styled, { css } from 'styled-components'
import GatsbyImage from 'gatsby-image'
import { Col, Row } from 'react-styled-flexboxgrid'
import House from './House'
import FormContainer from './form/FormContainer'
import Button from './Button'
import { colors, device } from '../styles/config'

const Container = styled.div`
  width: 100%;
  position: relative;

  &:after {
    position: absolute;
    content: '';
    bottom: 0;
    width: 100%;
    height: 400px;
    background-color: ${ colors.neutralLight };
    z-index: -1;
  }
`

const ContainerInner = styled.div`
  ${ props => props.theme.wrapper };
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
  overflow: hidden;
  border-bottom: 7.5rem solid ${ colors.neutralLight };
  /* padding-bottom: 10rem; */

  @media ${ device.sm } {
    position: initial;
    align-items: stretch;
  }
`

const TopText = styled.div`
  width: 45%;
  z-index: 1;
  padding-top: 5rem;
  min-height: 570px;
  display: flex;
  flex-direction: column;

  p {
    margin-bottom: 1rem;
  }

  @media ${ device.lg } {
    padding-top: 4rem;
  }

  @media ${ device.md } {
    padding-top: 0rem;
    width: 50%;
    min-height: 490px;
  }

  @media ${ device.sm } {
    width: initial;
    padding: 0;
    position: relative;
    top: -35px;
    padding-left: 2rem;
    padding-right: 2rem;
    margin-left: -2rem;
    margin-right: -2rem;
    min-height: initial;
    background: ${ colors.neutralLight };
    
    &:after {
      display: block;
      content: '';
      position: absolute;
      bottom: -60px;
      height: 60px;
      width: 120%;
      background: ${ colors.neutralLight };
      left: -20%;
      z-index: -1;
    }
  }
`

const HeaderButton = styled(Button)`
  ${ props => props.activeColor && css`
    background-color: ${ props.light ? 'white' : props.activeColor.default };
    color: ${ props.light ? props.activeColor.default : 'white' };

    @media ${ device.hover } {
      &:hover {
        color: ${ props.light ? props.activeColor.darkened : 'white' };
        background-color: ${ props.light ? 'white' : props.activeColor.darkened };

        svg {
          path {
            fill: ${ props.light ? props.activeColor.darkened : 'white' };
          }
        }
      }
    }

    svg {
      path {
        fill: ${ props.light ? props.activeColor.default : 'white' };
      }
    }
  ` }
  
  margin-top: auto;
  margin-bottom: 1rem;

  &:last-child {
    margin-top: 0;
    margin-bottom: 0;
  }

  @media ${ device.sm } {
    margin-top: 3rem;
    width: 100%;
  }
`

const Header = styled.h1`
  min-height: 8rem;

  @media ${ device.lg } {
    min-height: 7rem;
  }

  @media ${ device.md } {
    min-height: 6rem;
  }

  @media ${ device.sm } {
    min-height: initial;
  }

  ${ props => props.activeColor && css`
    color: ${ props.activeColor.default };
  ` }
`

const HouseHeader = ({ header, description, activeRoom, onAvailabiltyClick }) => {
  const [modalOpen, setModalOpen] = useState(false)
  const activeColor = getRoomColor(activeRoom)

  function openModal () {
    setModalOpen(true)
  }

  function closeModal () {
    setModalOpen(false)
  }

  return (
    <Container>
      <ContainerInner>
        <House activeRoom={activeRoom}/>
        <TopText>
          <Header activeColor={activeColor}>{header}</Header>
          <div dangerouslySetInnerHTML={{ __html: description }}/>
          <HeaderButton
            light
            activeColor={activeColor}
            onClick={() => { onAvailabiltyClick && onAvailabiltyClick() }}
          >
            Verfügbarkeit
          </HeaderButton>
          <HeaderButton
            activeColor={activeColor}
            onClick={openModal}
          >
            Anfragen
          </HeaderButton>
        </TopText>
      </ContainerInner>
      <FormContainer
        modalOpen={modalOpen}
        closeModal={closeModal}
      />
    </Container>
  )
}

function getRoomColor (name) {
  switch (name) {
  case 'brueckendeck':
    return {
      default: '#CF6452',
      darkened: '#c04935'
    }
  case 'sonnendeck':
    return {
      default: '#F6B268',
      darkened: '#f39836'
    }
  case 'theaterdeck':
    return {
      default: '#5293CF',
      darkened: '#357dc0'
    }
  case 'wiese':
    return {
      default: '#378577',
      darkened: '#2e7165'
    }
  // default:
  //   return {
  //     default: colors.secondary,
  //     darkened: colors.secondaryDarkened
  //   }
  }
}

HouseHeader.propTypes = {
}

export default HouseHeader
